<template>
  <div class="input_class">
    <el-input
      v-model="hh"
      placeholder="时"
      oninput=" value=value.replace(/[^\d]/g,'')"
      @change="changeTime"
    ></el-input>
    <el-input
      v-model="min"
      placeholder="分"
      oninput="if(value<0){return value = 0} if(value>59){return value = 59} value=value.replace(/[^\d]/g,'')"
      @change="changeTime"
    ></el-input>
    <el-input
      v-model="ss"
      placeholder="秒"
      oninput="if(value<0){return value = 0} if(value>59){return value = 59} value=value.replace(/[^\d]/g,'')"
      @change="changeTime"
    ></el-input>
    <span style="padding: 0 5px">至</span>
    <el-input
      v-model="hh2"
      placeholder="时"
      oninput="value=value.replace(/[^\d]/g,'')"
      @change="changeTime2"
    ></el-input>
    <el-input
      v-model="min2"
      placeholder="分"
      @change="changeTime2"
      oninput="if(value<0){return value = 0} if(value>60){return value = 60} value=value.replace(/[^\d]/g,'')"
    ></el-input>
    <el-input
      v-model="ss2"
      placeholder="秒"
      @change="changeTime2"
      oninput="if(value<0){return value = 0} if(value>60){return value = 60} value=value.replace(/[^\d]/g,'')"
    ></el-input>
    <i
      class="el-icon-circle-close"
      style="cursor:pointer"
      @click="clearTime"
      v-if="hh || min || ss || hh2 || min2 || ss2"
    ></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hh: "",
      min: "",
      ss: "",
      hh2: "",
      min2: "",
      ss2: "",
    };
  },
  methods: {
    changeTime(val) {
      let time = "";
      if (this.hh) {
        time = Number(this.hh * 60 * 60);
      } else {
        time = 0;
      }
      if (this.min) {
        time = Number(time + this.min * 60);
      } else {
        time = time;
      }

      if (this.ss) {
        time = Number(time + Number(this.ss));
      } else {
        time = time;
      }

      this.$emit("changeTime", time);
    },
    changeTime2(val) {
      let time = "";
      if (this.hh2) {
        time = Number(this.hh2 * 60 * 60);
      } else {
        time = 0;
      }
      if (this.min2) {
        time = Number(time + this.min2 * 60);
      } else {
        time = time;
      }
      if (this.ss2) {
        time = Number(time + Number(this.ss2));
      } else {
        time = time;
      }
      this.$emit("changeTime2", time);
    },
    clearTime() {
      this.hh = "";
      this.min = "";
      this.ss = "";
      this.hh2 = "";
      this.min2 = "";
      this.ss2 = "";
      this.$emit("changeTime", 0);
      this.$emit("changeTime2", 0);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner {
  width: 50px !important;
}
/deep/.el-input--small {
  margin: 0 5px;
  width: 50px !important;
}
/deep/.el-input__inner {
  padding: 0 5px !important;
}
.input_class {
}
</style>